import React, { useEffect, useState } from "react";
import Hero1 from '../components/Hero1';
import Hero from '../components/Hero';
import Hero2 from '../components/Hero2';
import CTA from '../components/CTA';
import SumStats from '../components/SumStats';
import Features2 from '../components/Features2';
import Partners from '../components/Partners';
import News from '../components/News';
import GPU from '../components/GPU';
import TimeLine from '../components/TimeLine';

import MCPServer from '../components/MCPServer';
import { Home1Data, Home11Data, Home12Data, StatusData3, Home2Data, HomeTimeLineData, PartnersData, GPUData, Home6Data, FeaturesData } from '../data/data.source';

const Home = () => {
  return (<>
    <Hero data={Home1Data} />
    <MCPServer />
    <Features2 id="products" data={Home11Data} />
    <Hero2 data={Home12Data} />
    <CTA />
    <Hero1 data={Home2Data} />
    <TimeLine data={HomeTimeLineData} />
    <Partners id="partners" data={PartnersData} />
    <News data={Home6Data} />
    <SumStats data={StatusData3} />
    <GPU data={GPUData} />
  </>
  );
};

export default Home